import React from 'react';

interface IBreakdownProps {
	size?: string;
}

export const Breakdown = ({ size = '164' }: IBreakdownProps) => {
	return (
		<svg
			role="img"
			width={size}
			height={Number(size) * 0.6}
			viewBox="0 0 164 99"
			fill="none"
			aria-labelledby="carBreakdownTitle">
			<title id="carBreakdownTitle">car breakdown icon</title>
			<g clipPath="url(#clip0_4309_3785)">
				<path
					d="M8.82883 98.0037H163.455C163.455 98.0037 166.913 74.5444 156.083 63.5846C141.794 49.183 108.849 42.2086 101.386 19.2022C93.9232 -3.80421 53.3327 -6.5215 35.0397 12.8618C16.7467 32.2452 37.588 40.9405 12.6513 57.8783C-12.2855 74.8161 8.82883 98.0037 8.82883 98.0037Z"
					fill="#EBEBEB"
				/>
				<path
					d="M52.9396 46.8435L119.344 50.8857C124.741 51.2142 129.785 53.6628 133.368 57.693C136.95 61.7231 138.778 67.0046 138.447 72.3755L137.353 90.1858C137.267 91.5765 136.63 92.8765 135.582 93.7997C134.533 94.7229 133.159 95.1938 131.762 95.1087L37.0156 89.3414C35.6182 89.2563 34.3121 88.6223 33.3844 87.5788C32.4568 86.5353 31.9836 85.1678 32.0691 83.7771L33.2803 64.0682C33.604 59.194 35.8539 54.6456 39.5379 51.4177C43.222 48.1899 48.0404 46.5453 52.9396 46.8435Z"
					fill="white"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M57.7918 67.4794L40.0449 66.3925C39.6424 66.3811 39.2463 66.2893 38.8802 66.1225C38.5141 65.9557 38.1854 65.7173 37.9137 65.4216C37.642 65.1258 37.4329 64.7787 37.2987 64.4009C37.1645 64.0231 37.108 63.6223 37.1325 63.2223L37.3146 60.9579C37.3592 60.1297 37.5936 59.3226 38 58.5985C38.4064 57.8744 38.9739 57.2524 39.6591 56.7803C40.3443 56.3082 41.129 55.9985 41.9531 55.8748C42.7771 55.7511 43.6187 55.8168 44.4133 56.0668L55.4255 59.4181C56.2255 59.6441 56.9236 60.1357 57.4038 60.8114C57.8839 61.487 58.1172 62.3059 58.0648 63.1318L57.7918 67.4794Z"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M114.309 70.8307L132.056 71.9177C132.45 71.9422 132.846 71.8889 133.219 71.761C133.593 71.633 133.938 71.4329 134.234 71.172C134.53 70.9111 134.771 70.5947 134.944 70.2408C135.117 69.8869 135.218 69.5026 135.241 69.1098L135.423 66.8454C135.464 66.0128 135.316 65.1817 134.989 64.4143C134.662 63.647 134.164 62.9632 133.534 62.4143C132.904 61.8654 132.157 61.4655 131.349 61.2447C130.541 61.0238 129.694 60.9877 128.87 61.1391L117.585 63.1317C116.779 63.2729 116.044 63.6804 115.499 64.2885C114.954 64.8966 114.631 65.6697 114.582 66.4831L114.309 70.8307Z"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M114.589 65.9433L57.9043 62.4929L57.5748 67.8541L114.259 71.3045L114.589 65.9433Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M86.2768 66.8454C87.9355 66.8454 89.2801 65.5072 89.2801 63.8564C89.2801 62.2056 87.9355 60.8673 86.2768 60.8673C84.6181 60.8673 83.2734 62.2056 83.2734 63.8564C83.2734 65.5072 84.6181 66.8454 86.2768 66.8454Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M47.4297 77.2209L123.009 81.8215L122.975 82.3639C122.85 84.402 121.917 86.3071 120.38 87.6601C118.843 89.0131 116.83 89.7032 114.782 89.5786L54.6455 85.918C52.5977 85.7933 50.6834 84.8642 49.3239 83.3349C47.9645 81.8056 47.2711 79.8014 47.3964 77.7634L47.4297 77.2209Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M111.761 26.4483L65.8008 23.6404C61.3413 23.3687 56.9728 25.8143 54.2425 30.2525L47.5078 46.1034L127.142 50.9039L122.5 34.3285C120.316 29.6185 116.311 26.72 111.761 26.4483Z"
					fill="#ffcc00"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M44.1391 38.4281L40.5055 38.2069C38.9503 38.1123 37.6123 39.2903 37.5172 40.8382L37.5139 40.8924C37.4188 42.4403 38.6025 43.7718 40.1577 43.8665L43.7913 44.0876C45.3466 44.1823 46.6845 43.0043 46.7796 41.4564L46.7829 41.4022C46.8781 39.8543 45.6944 38.5228 44.1391 38.4281Z"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M134.647 43.9199L131.013 43.6987C129.458 43.604 128.12 44.7821 128.025 46.3299L128.022 46.3842C127.927 47.932 129.11 49.2635 130.666 49.3582L134.299 49.5794C135.854 49.6741 137.192 48.496 137.287 46.9482L137.291 46.8939C137.386 45.3461 136.202 44.0146 134.647 43.9199Z"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M48.9643 98.0942H34.2207L34.8578 88.8554L49.4194 89.7612L48.9643 98.0942Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M111.76 26.4483L65.8002 23.6404C64.0126 23.5781 62.2327 23.9021 60.583 24.5901C58.9333 25.2781 57.453 26.3138 56.2441 27.6258L120.77 31.5206C119.734 30.0692 118.39 28.8624 116.833 27.9858C115.276 27.1092 113.544 26.5843 111.76 26.4483Z"
					fill="white"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M21.0234 98.0942H149.985" stroke="#A3A3A3" strokeWidth="2" />
				<path
					d="M142.158 63.6752C143.341 66.0302 143.614 71.9177 143.068 75.5407"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M140.611 87.5874L145.071 82.6057L142.978 90.5764L150.895 90.8481L145.344 94.3806"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M133.329 94.6523H132.874L118.767 93.7466L118.494 97.9131H133.329C133.763 97.9131 134.18 97.7413 134.487 97.4355C134.794 97.1298 134.967 96.7151 134.967 96.2827C134.967 95.8503 134.794 95.4356 134.487 95.1298C134.18 94.8241 133.763 94.6523 133.329 94.6523Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4309_3785">
					<rect width="164" height="99" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
